import dynamic from 'next/dynamic';

export const DynamicFilterSettingsDesktopPopover = dynamic(
  () =>
    import(/* webpackChunkName: 'FilterSettingsDesktopPopover' */ './FilterSettingsDesktopPopover'),
  {
    ssr: false,
  },
);
